// Dropdown controls for contact form

jQuery(".m-dropdown-contact a").each(function() {

    jQuery(this).bind("click",function(e){
        myquery = "#" + jQuery(this).closest(".m-dropdown").attr("data-query");
        mymenu = jQuery(this).closest(".dropdown");
        myvalue = jQuery(this).attr("data-value");
        jQuery(mymenu).find(".active").removeClass("active");
        jQuery(mymenu).find(".dropdowButtonTxt").html(jQuery(this).html());
        jQuery(this).parent().addClass("active");
        jQuery(myquery).val(myvalue);
        e.preventDefault();
    });

});


// Move labels on focus

jQuery(".gform-contact .ginput_complex.ginput_container input").focus(function() {
    jQuery(this).prev().addClass("active");
});

jQuery(".gform-contact .ginput_container:not(.ginput_complex) input, .gform-contact .ginput_container:not(.ginput_complex) textarea").focus(function() {
    jQuery(this).parent().prev().addClass("active");
});


//---------------------


// If the form is submitted with entries in fields:


// Move the labels

jQuery(".gform-contact .ginput_complex.ginput_container input").each(function() {
    if (jQuery(this).val() !== "") {
        jQuery(this).prev().addClass("active");
    }
});

jQuery(".gform-contact .ginput_container:not(.ginput_complex) input, .gform-contact .ginput_container:not(.ginput_complex) textarea").each(function() {
    if (jQuery(this).val() !== "") {
        jQuery(this).parent().prev().addClass("active");
    }
});


// Set the dropdown

if (jQuery("#input_2_7").val() !== "") {
    menuOption = ".m-dropdown-contact a[data-value='" + jQuery("#input_2_7").val() + "']";
    menuOptionParent = jQuery(menuOption).closest(".dropdown");
    jQuery(menuOption).parent().addClass("active");
    jQuery(menuOptionParent).find(".dropdowButtonTxt").html(jQuery(menuOption).html());
}